<template>
  <transition name="message-slide">
    <div 
      v-if="messageState.show"
      class="message-container"
      :class="messageClass"
      role="alert"
      :aria-live="messageState.level === 'danger' ? 'assertive' : 'polite'"
    >
      {{ messageState.message }}
      <button class="close-button" @click="hide" aria-label="Close message">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M13 1L1 13M1 1L13 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
  </transition>
</template>

<script setup>
import { computed } from 'vue'
import { useMessage } from '../services/messageServices'

const { messageState, hide } = useMessage()

const messageClass = computed(() => `message-${messageState.value.level}`)
</script>